
(ns manage.studio-preview.view
  (:require ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Stack$default" :as Stack]
            [common.error-page.view :refer [error-page]]
            [manage.studio-preview.db]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui studio-preview-page []
  (uix/use-effect (fn []
                    (rf/dispatch [:studio-preview/init])
                    (fn []
                      (rf/dispatch [:studio-preview/destroy])))
                  [])
  (let [state (use-subscribe [:studio-preview/state])]
    (if (= state :failure)
      ($ error-page {:code "studio_not_authorized_error"})
      ($ Stack {:justifyContent "center"
                :alignItems "center"
                :height "100%"}
         ($ CircularProgress)))))
